import type { RouteObject } from 'react-router-dom';
import { RoleGuard } from '@/shared/guards/RoleGuard';
import { CATALOG_ROLES } from '@/shared/guards/roles';
import { CatalogPage } from './pages/CatalogPage';
import { ProductDetailPage } from './pages/ProductDetailPage';

/**
 * Sub-árvore de rotas do módulo Catálogo. Gateada por `CATALOG_ROLES`
 * (ADMINISTRATOR; SYSTEM_ADMINISTRATOR é curinga) — quem passa neste guard
 * também escreve, então não há gate de escrita dentro das telas. É só UX; o back
 * enforce em `/admin/*`.
 */
export const catalogRoutes: RouteObject[] = [
  {
    element: <RoleGuard roles={CATALOG_ROLES} />,
    children: [
      {
        path: 'management/catalog',
        children: [
          {
            // `:tab?` opcional: a aba vive na URL (compartilhável, sobrevive a
            // refresh). Casa tanto `/management/catalog` quanto
            // `/management/catalog/perks`.
            path: ':tab?',
            element: <CatalogPage />,
          },
          {
            path: 'products/:productId',
            element: <ProductDetailPage />,
          },
        ],
      },
    ],
  },
];
